<div class="configMenu">
    <h3>Modus</h3>

    <div class="InputGroup">

        <SmartButton v-model="mode" set="walking_standard" unset="cycling_standard">Fußgänger</SmartButton>
        <SmartButton v-model="mode" set="cycling_standard" unset="walking_standard">Fahrrad</SmartButton>
        
    </div>


    <div>
        <h3>Geschwindigkeit</h3>
        <RangeSlider v-model="speed" value.sync="speed" min="1" max="20" step="1" unit="km/h"/>
    </div>

    <div>
        <h3>Reichweite</h3>
        <RangeSlider v-model="minutes" :value.sync="minutes" min="5" max="20" step="1" unit="Minuten"/>
    </div>

    <div style="margin:10px 0px">
        
    <SmartButton @click="closeMenu()">OK</SmartButton>
    <SmartButton @click="setConfig()">Übernehmen</SmartButton>
    
    </div>
</div>
